import { pluginConfig } from '../config.esm.js';

function isAWSS3ViewerAnnotationPresent(entity) {
  return Boolean(entity.metadata.annotations?.[pluginConfig.annotationKey]);
}
function parseAnnotation(entity) {
  const annotation = entity.metadata.annotations?.[pluginConfig.annotationKey] ?? null;
  if (!annotation) {
    throw new Error(
      `Annotation ${pluginConfig.annotationKey} doesn't exist on Entity '${entity.metadata.name}'`
    );
  }
  const [accountId, path] = annotation.split(":");
  const [bucketName, ...folderPaths] = path?.split("/") || [];
  const folder = folderPaths.filter((p) => p !== "/").filter(Boolean).join("/");
  return {
    accountId,
    bucketName,
    folder: folder && `${folder}/`
  };
}

export { isAWSS3ViewerAnnotationPresent, parseAnnotation };
//# sourceMappingURL=backstage.utils.esm.js.map
